/** An image that fails to load is replaced once by a random picture, seeded by the article so it stays the same. */
export const fallbackImage = (width: number, height: number, seed: number | string) => (event: Event) => {
  const target = event.target as HTMLImageElement;
  target.onerror = null;
  target.src = `https://picsum.photos/${width}/${height}?random=${seed}`;
};
